/* Stix PDP Stock-Aware Picker — Option E (Wizard / Help Me Choose)
 * ------------------------------------------------------------------
 * Entry button + drawer. 5-step quiz, inventory-aware. Each step shows
 * only options that lead to *some* in-stock path. Not-offered options
 * surface a cross-sell card; OOS options carry a "sold out — notify me"
 * subscript. On completion, the locked combo is applied to the live
 * radios so the regular variant tracking + ATC flow takes over.
 */
(function () {
  'use strict';
  var ARM = 'e';

  /* Question copy per dimension. Keyed loosely so we match whatever the
     merchant named the option. Order = priority (Length first). */
  var STEP_TEMPLATES = [
    { match: /length|size/i, dim: '',
      question: 'How tall are you?',
      help: 'Shaft length is the single biggest fit factor. Wrong length means worse contact and a swing that fights you.',
      labels: { 'Standard': { label: 'Average height', sub: "5'8\" – 6'2\"" },
                'Tall':     { label: 'Tall', sub: "6'2\" or taller" },
                'Short':    { label: 'Shorter', sub: "under 5'8\"" },
                'Petite':   { label: 'Petite', sub: "under 5'4\"" } } },
    { match: /hand|dex/i, dim: '',
      question: 'Which side do you swing from?',
      help: 'You grip with both hands. Right-handed golfers stand on the left of the ball and swing the club from right to left; left-handed golfers do the opposite.',
      labels: { 'Right': { label: 'Right-handed' }, 'Left': { label: 'Left-handed' } } },
    { match: /flex/i, dim: '',
      question: 'How far do you hit your driver?',
      help: "Pick the distance closest to where you tend to land. We'll set the right shaft flex to match.",
      labels: { 'Regular': { label: 'Around 200 yards', sub: 'Most golfers' },
                'Stiff':   { label: 'Around 230+ yards', sub: 'Fast swings' },
                'Active':  { label: 'Under 200 yards', sub: 'Slower, smoother swings' },
                'Senior':  { label: 'Easy tempo' },
                'Ladies':  { label: 'Easy tempo' } } },
    { match: /material/i, dim: '',
      question: 'Graphite or steel shafts?',
      help: 'Graphite is lighter — easier to swing. Steel is heavier with more feedback for stronger players.',
      labels: { 'Graphite': { label: 'Graphite', sub: 'Lighter · what most Stix sets ship with' },
                'Steel':    { label: 'Steel', sub: 'Heavier · more feedback' } } },
    { match: /bag/i, dim: '',
      question: 'Add a matching bag?',
      help: 'The Stix stand bag is dialed in for these clubs. Skip if you already love your bag.',
      labels: { 'With Bag': { label: 'Yes, include the bag', sub: '+$100 · matching Stix stand bag' },
                'No Bag':   { label: 'Clubs only', sub: 'Base price' } } }
  ];

  /* Two activation paths:
     (1) If the router fired its event BEFORE this script loaded, check the
         globals it set synchronously and init immediately if our arm is live.
     (2) Otherwise listen for the event.
     Without (1), deferred scripts that load after the router miss the event. */
  function maybeInit() {
    var arm = window.STIX_TEST && window.STIX_TEST['pdp_stockaware_picker'];
    if (arm !== ARM) return;
    if (!window.StixPicker || !window.StixPicker.catalog) { setTimeout(maybeInit, 50); return; }
    init();
  }
  document.addEventListener('cl-picker-router:activated', function (e) { if (e.detail && e.detail.arm === ARM) maybeInit(); });
  document.addEventListener('cl-picker-catalog-ready', maybeInit);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maybeInit);
  } else {
    maybeInit();
  }

  function init() {
    var root = document.querySelector('[data-cl-picker-E]');
    if (!root) return;
    if (root.dataset.clInited) return;
    root.dataset.clInited = '1';
    var catalog = StixPicker.catalog;

    /* Build the actual STEPS list from the product's option names matched
       to STEP_TEMPLATES. Skip templates that don't apply. */
    var STEPS = [];
    STEP_TEMPLATES.forEach(function (tpl) {
      var dim = catalog.optionNames.find(function (n) { return tpl.match.test(n); });
      if (!dim) return;
      STEPS.push(Object.assign({}, tpl, { dim: dim }));
    });
    /* Append any unmapped option names (so we don't silently drop them) */
    catalog.optionNames.forEach(function (n) {
      if (!STEPS.find(function (s) { return s.dim === n; })) {
        STEPS.push({ dim: n, question: 'Choose ' + n, help: '', labels: {} });
      }
    });

    var sel = {};
    var currentStep = 0;
    var wallShown = null;
    var oosMount = root.querySelector('[data-cl-oos-mount]');
    var oosHero = StixPicker.attachOosHero(oosMount, ARM);


    var barEl = root.querySelector('[data-cl-e-bar]');
    var bodyEl = root.querySelector('[data-cl-e-body]');
    var recapEl = root.querySelector('[data-cl-e-recap]');

    /* Wizard renders inline immediately. No open/close. */
    StixPicker.fireEvent('Wizard Started', { wizard: 'pdp-help-me-choose' }, ARM);
    /* No-op stub so existing renderStep code paths that call `close()`
       on the final ATC don't break. */
    function close() {}

    /* Reachability — what's the best in-stock status reachable for this
       value at this step, given prior locked picks? */
    function reachableStatus(dim, val, locked) {
      var idx = catalog.optionNames.indexOf(dim);
      var best = 'not-offered';
      catalog.variants.forEach(function (v) {
        if (v.options[idx] !== val) return;
        for (var k in locked) {
          var li = catalog.optionNames.indexOf(k);
          if (li >= 0 && v.options[li] !== locked[k]) return;
        }
        if (v.available) best = 'in-stock';
        else if (best !== 'in-stock') best = 'oos';
      });
      return best;
    }
    function inStockCount(dim, val, locked) {
      var idx = catalog.optionNames.indexOf(dim);
      var c = 0;
      catalog.variants.forEach(function (v) {
        if (v.options[idx] !== val) return;
        if (!v.available) return;
        for (var k in locked) {
          var li = catalog.optionNames.indexOf(k);
          if (li >= 0 && v.options[li] !== locked[k]) return;
        }
        c++;
      });
      return c;
    }

    /* All values per dim, in catalog appearance order */
    function valsFor(dim) {
      var idx = catalog.optionNames.indexOf(dim);
      var out = [];
      catalog.variants.forEach(function (v) {
        if (out.indexOf(v.options[idx]) === -1) out.push(v.options[idx]);
      });
      return out;
    }

    function renderBar() {
      barEl.innerHTML = '';
      for (var i = 0; i < STEPS.length; i++) {
        var d = document.createElement('div');
        d.className = 'cl-picker-E__step-bar-step';
        if (i < currentStep) d.classList.add('is-done');
        else if (i === currentStep) d.classList.add('is-active');
        barEl.appendChild(d);
      }
      /* Step counter in the header row */
      var stepCounter = root.querySelector('[data-cl-e-step-counter]');
      if (stepCounter) {
        var n = Math.min(currentStep + 1, STEPS.length);
        stepCounter.textContent = 'Step ' + n + ' of ' + STEPS.length;
      }
    }

    function renderRecap() {
      var items = STEPS.slice(0, currentStep)
        .map(function (s) {
          return '<span class="item"><strong>' + s.dim + ':</strong> ' + sel[s.dim] + '</span>';
        }).join('');
      recapEl.innerHTML = items + (currentStep > 0 ? '<br><button type="button" class="cl-picker-E__back" data-cl-e-back>← Start over</button>' : '');
      var back = recapEl.querySelector('[data-cl-e-back]');
      if (back) back.addEventListener('click', function () {
        currentStep = 0;
        sel = {};
        wallShown = null;
        renderAll();
      });
    }

    function renderWall(locked) {
      var key = wallKey(locked);
      var altProd = StixPicker.oosRecs.primarySub;
      var closest = StixPicker.closestInStock(locked);
      var closestSummary = closest
        ? catalog.optionNames.map(function (n, i) { return '<strong>' + closest.variant.options[i] + '</strong>'; }).join(' · ')
        : 'no in-stock match in this product';

      var closestCopy;
      if (closest) {
        var diffs = [];
        catalog.optionNames.forEach(function (n, i) {
          if (locked[n] && closest.variant.options[i] !== locked[n]) {
            diffs.push('<strong>' + closest.variant.options[i] + '</strong> ' + n.toLowerCase());
          }
        });
        closestCopy = diffs.length === 0
          ? 'Exact match is back in stock — pick this.'
          : diffs.length === 1
            ? 'Same set, just in ' + diffs[0] + '. Ships in 1-2 days.'
            : 'Closest in-stock combo: ' + diffs.slice(0, -1).join(', ') + ' and ' + diffs[diffs.length-1] + '.';
      } else {
        closestCopy = "We don't have a close match in this product line — see the alternative below.";
      }

      bodyEl.innerHTML = ''
        + '<div class="cl-picker-E__step-num" style="color:#ffb800;">Heads up · this combination is limited</div>'
        + '<h4 class="cl-picker-E__step-q" id="cl-e-step-q">We don&rsquo;t have this exact pick in stock right now.</h4>'
        + '<div class="cl-picker-E__step-help">You picked: ' + Object.values(locked).map(function (v) { return '<strong>' + v + '</strong>'; }).join(' · ') + '.</div>'
        + '<div class="cl-picker-E__options-stack">'
        +   '<button type="button" class="cl-picker-E__opt" data-cl-e-wall="closest">'
        +     (closest ? '✓ Use what&rsquo;s in stock' : '⚠ No same-product match')
        +     '<span class="cl-picker-E__opt-sub">' + closestCopy + '</span>'
        +     (closest ? '<span class="cl-picker-E__opt-sub" style="color:#6aff8a;">In stock: ' + closestSummary + '</span>' : '')
        +   '</button>'
        +   (altProd ? '<button type="button" class="cl-picker-E__opt is-muted" data-cl-e-wall="alt">'
                    + '→ Try ' + altProd.title
                    + '<span class="cl-picker-E__opt-sub">' + (altProd.reason || '') + '</span>'
                    + '</button>' : '')
        +   '<button type="button" class="cl-picker-E__opt" data-cl-e-wall="notify" style="border-color:rgba(255,184,0,0.30);">'
        +     '🔔 Keep my pick · notify me when it&rsquo;s back'
        +     '<span class="cl-picker-E__opt-sub">We will email you the moment this combo is restocked.</span>'
        +   '</button>'
        + '</div>';

      StixPicker.fireEvent('Wizard Wall Shown', { step: currentStep+1, locked: StixPicker.variantLabel(locked), wall_key: key }, ARM);

      bodyEl.querySelector('[data-cl-e-wall="closest"]').addEventListener('click', function () {
        if (!closest) return;
        StixPicker.fireEvent('Wizard Wall Click', { choice: 'closest-in-stock', from: StixPicker.variantLabel(locked), to: StixPicker.variantLabel(closest.sel) }, ARM);
        sel = Object.assign({}, closest.sel);
        currentStep = STEPS.length;
        wallShown = null;
        renderAll();
      });
      var altBtn = bodyEl.querySelector('[data-cl-e-wall="alt"]');
      if (altBtn) altBtn.addEventListener('click', function () {
        StixPicker.fireEvent('Cross-Sell Click', { source: 'wizard-wall', product: altProd.title, url: altProd.url }, ARM);
        if (altProd.url) window.location.href = altProd.url;
      });
      bodyEl.querySelector('[data-cl-e-wall="notify"]').addEventListener('click', function () {
        StixPicker.fireEvent('Wizard Wall Click', { choice: 'notify-me', locked: StixPicker.variantLabel(locked) }, ARM);
        sel = Object.assign({}, locked);
        currentStep = STEPS.length;
        wallShown = null;
        renderAll();
      });
    }

    function wallKey(locked) {
      /* Compact identifier for analytics: hand+flex+length suffix from locked picks */
      var keyVals = catalog.optionNames.map(function (n) {
        var v = locked[n];
        return v ? v.charAt(0) : '';
      }).join('');
      return keyVals || 'default';
    }

    function renderStep() {
      if (currentStep >= STEPS.length) {
        /* Final step — apply selection and show ATC */
        var status = StixPicker.variantStatus(sel);
        var variant = StixPicker.findVariant(sel);
        var price = variant ? '$' + variant.price.toFixed(2).replace(/\.00$/, '') : '';
        var priceHTML, btnLabel, btnDisabled;

        if (status === 'in-stock') {
          priceHTML = '<div class="cl-picker-E__final-price">' + price + '</div>'
                    + '<div style="font-size:11px; color:#6aff8a;">✓ In stock · ships in 1–2 days</div>';
          btnLabel = 'ADD TO CART';
          btnDisabled = false;
        } else if (status === 'oos') {
          priceHTML = '<div class="cl-picker-E__final-price" style="color:#ffb800;">Sold out</div>'
                    + '<div style="font-size:11px; color:#BFBFC0;">Best in-stock alternative below — or sign up for back-in-stock</div>';
          btnLabel = 'SEE ALTERNATIVES';
          btnDisabled = true;
        } else {
          priceHTML = '<div class="cl-picker-E__final-price" style="color:#BFBFC0;">—</div>'
                    + '<div style="font-size:11px; color:#BFBFC0;">This configuration isn&rsquo;t made — alternatives below</div>';
          btnLabel = 'NO MATCH';
          btnDisabled = true;
        }

        var cartForm = document.querySelector('form[action*="/cart/add"]');
        var formId = cartForm && cartForm.id ? cartForm.id : '';
        bodyEl.innerHTML = ''
          + '<h4 class="cl-picker-E__step-q" id="cl-e-step-q">Your match: ' + catalog.productTitle + '</h4>'
          + '<div class="cl-picker-E__step-help">Built to your specs based on the answers above.</div>'
          + '<div class="cl-picker-E__final">' + priceHTML
          + '<button class="cl-picker-E__final-atc product__add-to-cart" data-cl-e-atc'
            + (formId ? ' type="submit" form="' + formId + '"' : ' type="button"')
            + (btnDisabled ? ' disabled' : '')
          + '>' + btnLabel + '</button>'
          + '</div>';

        if (!btnDisabled) {
          bodyEl.querySelector('[data-cl-e-atc]').addEventListener('click', function (e) {
            /* Lock the variant in the hidden form radios so productForm picks
               up the right variant_id. Then let the button submit the form
               naturally (it has type=submit form=<formId>), which triggers
               the live cartJs.addItems path. We do NOT preventDefault. */
            StixPicker.applyVariant(sel);
            StixPicker.fireVariantEvents(sel, ARM);
            StixPicker.fireEvent('Wizard Completed', {
              sku: variant ? variant.sku : '',
              variant_options: StixPicker.variantLabel(sel),
              stock_status: status
            }, ARM);
            /* Don't preventDefault — let the type=submit form=<id> button
               do its job. */
          });
        }

        StixPicker.applyVariant(sel);
        StixPicker.fireVariantEvents(sel, ARM);
        oosHero.update(sel, status);
        return;
      }

      /* Mid-wizard step */
      var step = STEPS[currentStep];
      var locked = {};
      STEPS.slice(0, currentStep).forEach(function (s) { locked[s.dim] = sel[s.dim]; });

      var optionStatuses = valsFor(step.dim).map(function (val) {
        return {
          val: val,
          status: reachableStatus(step.dim, val, locked),
          inStockCount: inStockCount(step.dim, val, locked),
          labelInfo: (step.labels && step.labels[val]) || { label: val, sub: '' }
        };
      });
      var anyInStock = optionStatuses.some(function (o) { return o.status === 'in-stock'; });
      if (!anyInStock && wallShown !== currentStep) {
        wallShown = currentStep;
        oosHero.update({}, 'in-stock'); /* hide hero in wall mode */
        renderWall(locked);
        return;
      }

      var totalInStock = optionStatuses.reduce(function (s, o) { return s + o.inStockCount; }, 0);
      var optsHTML = optionStatuses.map(function (o) {
        if (o.status === 'not-offered') {
          var alt = StixPicker.oosRecs.primarySub;
          var lockedDescr = Object.values(locked).join(' + ');
          var curProd = catalog.productTitle.replace(/^P\d+\s+/, '');
          var why = alt
            ? curProd + ' not available in ' + o.labelInfo.label + ' for ' + lockedDescr + ', but ' + alt.title + ' is.'
            : curProd + ' not available in ' + o.labelInfo.label + ' for ' + lockedDescr + '.';
          return '<div class="cl-picker-E__not-offered" data-cl-e-no="' + o.val + '">'
              + '<div class="label">' + o.labelInfo.label + ' · not offered</div>'
              + '<div class="why">' + why + '</div>'
              + (alt ? '<button type="button" class="cl-picker-E__alt-cta" data-cl-e-alt="' + o.val + '">Browse ' + alt.title + ' →</button>' : '')
              + '</div>';
        }
        var muted = (o.status === 'oos') ? 'is-muted' : '';
        var subTxt = o.labelInfo.sub || '';
        if (o.status === 'oos') subTxt = subTxt ? subTxt + ' · sold out — notify me' : 'sold out — notify me';
        else if (o.inStockCount > 0) subTxt = subTxt ? subTxt + ' · ' + o.inStockCount + ' in stock' : (o.inStockCount + ' in stock');
        var subHTML = subTxt ? '<span class="cl-picker-E__opt-sub">' + subTxt + '</span>' : '';
        return '<button type="button" class="cl-picker-E__opt ' + muted + '" data-cl-e-pick="' + o.val + '">' + o.labelInfo.label + subHTML + '</button>';
      }).join('');

      bodyEl.innerHTML = ''
        + '<h4 class="cl-picker-E__step-q" id="cl-e-step-q">' + step.question + '</h4>'
        + '<div class="cl-picker-E__step-help">' + step.help + '</div>'
        + '<div class="cl-picker-E__options-stack">' + optsHTML + '</div>'
        + '<div class="cl-picker-E__step-avail"><strong>' + totalInStock + '</strong> in-stock combination' + (totalInStock===1?'':'s') + ' reachable</div>';

      StixPicker.fireEvent('Wizard Step Viewed', { step_index: currentStep+1, step_dim: step.dim, in_stock_reachable: totalInStock }, ARM);

      oosHero.update({}, 'in-stock'); /* hide hero in mid-wizard */

      bodyEl.querySelectorAll('[data-cl-e-pick]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = btn.getAttribute('data-cl-e-pick');
          StixPicker.fireEvent('Wizard Answer', { step_index: currentStep+1, step_dim: step.dim, value: val }, ARM);
          sel[step.dim] = val;
          currentStep++;
          wallShown = null;
          renderAll();
        });
      });
      bodyEl.querySelectorAll('[data-cl-e-alt]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = btn.getAttribute('data-cl-e-alt');
          var alt = StixPicker.oosRecs.primarySub;
          StixPicker.fireEvent('Cross-Sell Click', {
            source: 'wizard-not-offered',
            step_dim: step.dim,
            blocked_value: val,
            locked: StixPicker.variantLabel(locked),
            product: alt ? alt.title : '',
            url: alt ? alt.url : ''
          }, ARM);
          if (alt && alt.url) window.location.href = alt.url;
        });
      });
    }

    function renderAll() {
      renderBar();
      renderStep();
      renderRecap();
    }

    /* Kick off the wizard render now that everything is set up */
    renderAll();
  }
})();
